import React, { useRef } from "react";
import Carousel from "react-elastic-carousel";
import { Helmet } from "react-helmet";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import * as styles from "../styles/corousel.module.css";
import Expand from "../assets/expand.png";

const itemsPerPage = 1;
let resetTimeout;

const Corousal = ({ userData }) => {
  let imageRef = React.createRef();
  
  const renderImage = (photoUrl, altText, key, isFirst = false) => {
    if (!photoUrl) return null;
    
    return (
      <div key={key}>
        <a
          ref={isFirst ? imageRef : null}
          id={isFirst ? "first-image" : undefined}
          href={photoUrl}
          data-lightbox="profilePic"
        >
          <LazyLoadImage
            className="carousel-image"
            src={photoUrl}
            alt={altText}
            effect="blur"
            placeholder={<div style={{height: '300px', backgroundColor: '#f0f0f0'}} />}
          />
        </a>
      </div>
    );
  };

  return (
    <div className={styles.carousalWrapper}>
      <Helmet>
        <link rel="stylesheet" href="/lightbox/lightbox.min.css" />
        <script src="/lightbox/lightbox.min.js" />
      </Helmet>

      <Carousel itemsToShow={itemsPerPage}>
        {renderImage(userData[0]?.Photo1_URL, userData[0]?.Alt_Text_Photo1, 1, true)}
        {renderImage(userData[0]?.Photo2_URL, userData[0]?.Alt_Text_Photo2, 2)}
        {renderImage(userData[0]?.Photo3_URL, userData[0]?.Alt_Text_Photo3, 3)}
        {renderImage(userData[0]?.Photo4_URL, userData[0]?.Alt_Text_Photo4, 4)}
        {renderImage(userData[0]?.Photo5_URL, userData[0]?.Alt_Text_Photo5, 5)}
        {userData[0]?.Video && (
          <div key={7} class="carousel-video-container">
            <div class="carousel-video">
              <iframe
                width="560"
                height="315"
                src={"https://www.youtube.com/embed/" + userData[0]?.Video}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        )}
      </Carousel>
      <div className={styles.expandImg}>
        <img
          src={Expand}
          alt="Icon to view photos in full screen"
          onClick={() => {
            imageRef.current.click();
          }}
        />
      </div>
    </div>
  );
};

export default Corousal;
